import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpCommonActions } from "../../actions/mp-common.actions";
import { CurrencyState } from "../../models/mp-common/currency-state";

const initialState: CurrencyState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpCommonActions.currencies.getApi, (state) => ({ ...state, loading: true })),
	on(MpCommonActions.currencies.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		..._.omit(action, "type")
	})),
	on(MpCommonActions.currencies.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function currencyReducer(state: CurrencyState | undefined, action: Action): CurrencyState {
	return reducer(state, action);
}
